import React from 'react';
import { IconS24Trophy24 } from '@is24/cosma-ui-icons';
import { Indicator } from 'is24-corecss';
export function ImmoAwardLabel(_ref) {
  var variant = _ref.variant;
  var label = variant === 'winner' ? 'ImmoAward Winner' : 'ImmoAward Finalist';
  return /*#__PURE__*/React.createElement(Indicator, {
    appearance: "label",
    labelColor: "gray",
    labelVariant: "elevated",
    leftIcon: /*#__PURE__*/React.createElement(IconS24Trophy24, null)
  }, label);
}